module.exports = __webpack_public_path__ + "static/media/icon-history-not-available.60cb7e6a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/WorkBar/icon-history-not-available.svg
// module id = 1865
// module chunks = 0